export default __webpack_public_path__ + "static/media/Darkblade's Armbands of Consumed Souls.66ba4ff0.jpg";